import {flowState} from './flow'
import {gateStates,type Item,type Job} from './model'
import {infrastructureHeld} from './unstickModel'

export type Group='waiting'|'running'|'stuck'|'done'
export const groupLabels:Record<Group,string>={waiting:'ממתין לך',running:'רץ',stuck:'תקוע',done:'נסגרו או הושהו היום'}
export const groupOrder:Group[]=['waiting','running','stuck','done']
const critical=(item:Item)=>item.priority==='critical'||item.ticket?.bug_severity==='critical'||item.direction?.bug_severity==='critical'
const doneStates=['released','message_sent','no_fix','superseded','parked']
export function workspaceGroup(item:Item,jobs:Job[]):Group{
 if(doneStates.includes(item.state))return 'done'
 if(flowState(item,jobs).blocked)return 'stuck'
 if(gateStates.includes(item.state)&&!['new','answering'].includes(item.state))return 'waiting'
 return 'running'
}
export function groupedItems(items:Item[],jobs:Job[],now=new Date(),includeHistory=false){
 const day=(value:Date)=>value.toLocaleDateString('en-CA',{timeZone:'Asia/Jerusalem'})
 return groupOrder.map(id=>({id,label:id==='done'&&includeHistory?'הסתיים':groupLabels[id],items:items.filter(i=>i.state!=='superseded'&&workspaceGroup(i,jobs)===id&&(includeHistory||id!=='done'||day(new Date(i.updated_at))===day(now))).sort((a,b)=>Number(critical(b))-Number(critical(a))||b.updated_at.localeCompare(a.updated_at))}))
}
export function primaryAction(item:Item,jobs:Job[]){
 const group=workspaceGroup(item,jobs)
 if(group==='stuck')return infrastructureHeld(item)||item.workflow_stop?.code==='missing_source'?null:{key:'continue',label:'המשך עם הבחירה'}
 if(group!=='waiting'){
  if(item.kind==='ticket'&&item.state==='releasing'&&!item.message_approved_at)return {key:'message',label:'אשר ושלח תשובה'}
  return null
 }
 if(item.state==='direction_ready')return {key:'direction',label:(item.level??0)>=3?'אשר כיוון ופתח תוכנית':'אשר כיוון ושלח לתיקון'}
 if(item.state==='plan_ready')return {key:'plan',label:'אשר תוכנית עם הבחירות'}
 if(item.state==='screens_ready')return {key:'screens',label:'אשר מסכים והתחל לבנות'}
 if(item.state==='ready')return {key:'release',label:'אשר ושחרר הלילה'}
 if(item.state==='fix_ready')return item.message_only||item.fix_approved_at?{key:'message',label:'אשר ושלח תשובה'}:{key:'fix',label:'אשר תיקון והודעה'}
 return null
}
export const stageLabels=['כיוון','אישורך','בנייה','בדיקות','אישורך','שחרור']
export function stageIndex(item:Item,jobs:Job[]){
 const state=flowState(item,jobs).blocked?jobs.find(j=>j.id===item.active_job)?.kind??item.state:item.state
 return ({new:0,diagnose:0,answer:0,answering:0,plan:0,direction_ready:1,plan_ready:1,screens:1,screens_ready:1,build:2,fix:2,verify:3,ready:4,fix_ready:4,releasing:5,confirming:5,released:5,message_sent:5,no_fix:5} as Record<string,number>)[state]??0
}
export function choiceSummary(decisions:{id:string;title:string;options:{id:string;label:string}[]}[],answers:Record<string,{option?:string;custom?:string}>){
 return decisions.map(d=>`${d.title}: ${answers[d.id]?.custom??d.options.find(o=>o.id===answers[d.id]?.option)?.label??''}`).join('\n')
}
